// src/lib/lazyTracking.js
// PERF: keep public/SEO pages light.
// These wrappers lazy-load the tracking modules only when needed.

export async function lazyTrackEvent(payload) {
  try {
    const mod = await import('@/api/trackEvent')
    return await mod.trackEvent(payload)
  } catch {
    return false
  }
}

export async function lazySendMetaEvent(payload) {
  try {
    const mod = await import('@/api/metaCapi')
    return await mod.sendMetaEvent(payload)
  } catch {
    return null
  }
}
